import { TemplateItem } from "@/@types/flows/emailTemplates/items";

export enum TemplateType {
  Default = 1,
  Html = 2,
}

export enum TemplateState {
  Active = 1,
  Inactive = 2,
}

export interface Template {
  id: number;
  template_type: TemplateType;
  template: string;
  name: string;
  description: string;
  status: TemplateState;
  items: TemplateItem[];
  deleted_variable: boolean;
  updated_at: string;
  parameters: { name: string }[];
}

export interface Variable {
  name: string;
}
